

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { Backdrop, Box, Button, Grid, Typography } from '@mui/material';
import CustomInputLogin from '../../../../Components/CustomInputLogin/CustomInputLogin';
import { Formik, Form } from 'formik';
import CustomExcelUpload from '../../../../Components/CustomExcelUpload/CustomExcelUpload';
import { BackHandSharp, Upload } from '@mui/icons-material';
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from '../../../../Components/Table/CustomTable';
import actions from '../../../../ReduxStore/actions';
import CustomInputForm from '../../../../Components/CustomInputLogin/CustomInputForm';
import { toast, ToastContainer } from 'react-toastify';
import { bulkUploadKraKpisAction } from '../../../../ReduxStore/Slices/KRA&KPI/bulkUploadKraKpis';
import * as Yup from 'yup';
import { adminUrl } from '../../../../constants';
import InvalidRowsModal from '../../../../Components/InvalidRowsModal/InvalidRowsModal';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';

const validationSchema = Yup.object().shape({
    krakpi: Yup.string()
        .trim()
        .when('file', {
            is: (file) => !file, // if file is null or undefined
            then: (schema) => schema.required('krakpi name is required.'),
            otherwise: (schema) => schema.notRequired(),
        }),
    file: Yup.mixed().nullable(),
});
const KraKpi = () => {
    const dispatch = useDispatch();
    const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
    const tableHeadData = ["S.No", "KRA & KPI", "Actions"];
    const tableData = [
        { KraKpiId: "3", KraKpi: "ASSEMBLY SUPERVISOR-34" },
        { KraKpiId: "4", KraKpi: "ASSEMBLY SUPERVISOR-35" },
        { KraKpiId: "5", KraKpi: "ASSEMBLY SUPERVISOR-36" },
        { KraKpiId: "6", KraKpi: "ASSEMBLY SUPERVISOR-37" },

    ]


    useEffect(() => {
        dispatch(setHeaderName("Master"));
        dispatch(setSubHeaderName("KRA & KPI"));
    }, [dispatch]);

    const [editData, setEditData] = useState()
    const { updateKraKpi } = useSelector((state) => state?.updateKraKpi);
    const { createKraKpi } = useSelector((state) => state?.createKraKpi);
    const { bulkUploadKraKpis } = useSelector((state) => state?.bulkUploadKraKpis);



    const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
    const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState([]);

    const handleInvalidRowsModalOpen = () => {
        setInvalidRowsModalOpen(true)
    }
    const handleInvalidRowsModalClose = () => {
        setInvalidRowsModalOpen(false)
    }
    const [loading, setLoading] = useState(false);



    const handleSubmit = async (values, { resetForm }) => {
        console.log(values, "valuesssssss")
        setLoading(true)


        if (values?.file === null) {
            const data1 = {
                data: {
                    kra_kpi_name: values?.krakpi
                },
                method: editData?.kra_kpi_id ? "put" : "post",
                apiName: editData?.kra_kpi_id ? `updateKraKpi/${editData?.kra_kpi_id}` : "createKraKpi"
            };
            const responseData = await dispatch(editData?.kra_kpi_id ? actions.UPDATEKRAKPI(data1) : actions.CREATEKRAKPI(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "kra_kpi_name fetched successfully.") {
                setLoading(false)
                toast.success("KRA&KPI created successfully.")
                resetForm()
            } else if (responseData?.payload?.message === "KRA/KPI updated.") {
                setLoading(false)
                toast.success("KRA&KPI upadated successfully.")
                setEditData()
            }
            else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }
        } else {
            const formData = new FormData();
            formData.append("file", values?.file);
            console.log(formData, "formData")
            const data1 = {
                data: formData,
                method: "post",
                apiName: "bulkUploadKraKpis/bulk"
            };
            const responseData = await dispatch(actions.BULKUPLOADKRAKPIS(data1));
            console.log(responseData, "responseData")
            if (responseData?.payload?.message === "Bulk upload successful.") {
                setLoading(false)
                setInvalidRwModalResponseData(responseData?.payload?.data)
                handleInvalidRowsModalOpen(true)
                resetForm()
            } else {
                setLoading(false)
                toast.error(responseData?.payload?.message)
            }

        }



    }

    // const handleSamplDownload = () => {
    //     // const data1 = {
    //     //     data: {},
    //     //     method: "get",
    //     //     apiName: "downloadAllKraKpis/excel"
    //     // };
    //     // const responseData = dispatch(actions.DOWNLOADKRAKPIS(data1));
    //     window.open(`${adminUrl}downloadkrakpissampleexcelfile`);


    // }
    const authToken = localStorage.getItem("authToken")
    const handleSamplDownload = async () => {
        try {
            const response = await fetch(`${adminUrl}downloadkrakpissampleexcelfile`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`, // Replace with actual token
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'KRA&KAPI_Name_Sample.xlsx'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
        }
    };
    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")


    const { getAllKraKpi } = useSelector((state) => state?.getAllKraKpi);
    console.log(getAllKraKpi, "getAllKraKpi")


    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllKraKpi"
            };
            const responseData = dispatch(actions.GETALLKRAKPI(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [updateKraKpi, createKraKpi, bulkUploadKraKpis])

    useEffect(() => {

        const tempArr = [];

        getAllKraKpi?.data?.map((data, index) => {
            return tempArr.push({
                // id: data?.internship_id,
                id: data?.kra_kpi_id,
                kra_kpi_name: data?.kra_kpi_name
            });
        });
        setRowTableData(tempArr);




    }, [getAllKraKpi])




    const { getKraKpiById } = useSelector((state) => state?.getKraKpiById);


    const handleTableEdit = async (id) => {
        setShowExcelUpload(false)
        setLoading(true)
        window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top

        console.log(id, "idgretoriut")
        const data1 = {
            data: {},
            method: "get",
            apiName: `getKraKpiById/${id}`
        };
        const responseData = await dispatch(actions.GETKRAKPIDBYID(data1));
        console.log(responseData, "getKraKpiById")
        if (responseData?.payload?.message === "All kra_kpi_id fetched successfully.") {
            setLoading(false)
            setEditData(responseData?.payload?.data)
        }


    }

    return (
        <Box>
            {loading && <FullPageLoader />}
            <Box
                sx={{
                    background: "white",
                    p: 3
                }}
            >
                <Box
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                    <Typography variant='subtitle2' sx={{ color: "black", fontSize: "18px" }}>
                        {showExcelUpload ? 'Upload Excel' : 'Add KRA & KPI'}
                    </Typography>
                    <Typography
                        variant='body1'
                        // onClick={() => setShowExcelUpload(!showExcelUpload)}

                        onClick={() => {
                            setShowExcelUpload(!showExcelUpload)
                            setEditData()
                        }} sx={{
                            textAlign: "end",
                            color: 'var(--main-color)',
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer"
                        }}
                    >
                        {showExcelUpload ? <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} /> : <Upload sx={{ mr: 1 }} />}
                        {showExcelUpload ? 'Back to Form' : 'Upload Excel'}
                    </Typography>
                </Box>

                <Formik
                    enableReinitialize
                    initialValues={{
                        krakpi: editData?.kra_kpi_name || '',
                        file: null
                    }}
                    validationSchema={validationSchema}

                    onSubmit={handleSubmit}
                >
                    {({ errors, touched, handleChange, values, setFieldValue, resetForm }) => (
                        <Form>
                            <Grid container spacing={2} mt={2}>
                                <Grid item size={{ xs: 12, md: 6 }}>
                                    {showExcelUpload ? (
                                        <>
                                            <CustomExcelUpload
                                                values={values}
                                                setFieldValue={setFieldValue}
                                                resetForm={resetForm}
                                            />
                                            {/* <Typography variant='body1'
                                                sx={{
                                                    // borderBottom: "1px solid var(--main-color)",
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >Download & Sample Excel Format</Typography> */}
                                            {/* <a href="/sample.xlsx" download style={{ textDecoration: 'none' }}> */}
                                            <Typography
                                                onClick={handleSamplDownload}

                                                variant="body1"
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "var(--main-color)"
                                                }}
                                            >
                                                Download & Sample Excel Format
                                            </Typography>
                                            {/* </a>/ */}

                                        </>
                                    ) : (
                                        <CustomInputForm
                                            name="krakpi"
                                            label="KRA & KPI"
                                            custPlaceholder="Ex.ASSEMPLY-45"
                                        />
                                    )}
                                </Grid>

                                {/* {!showExcelUpload && ( */}
                                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                                    <Button
                                        type="submit"
                                        variant='contained'
                                        sx={{
                                            background: "var(--main-color)",
                                            textTransform: "none"
                                        }}
                                    >
                                        {editData?.kra_kpi_id ? "Update" : "Submit"}

                                    </Button>
                                </Grid>
                                {/* )} */}
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </Box>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6
                }}
            >
                <CustomTable
                    tableHeadData={tableHeadData}
                    tableData={rowTableData}
                    title="KRA & KPI List"
                    tableEdit={true}
                    tableActions={true}
                    tableSearch={true}
                    handleTableEdit={handleTableEdit}

                />
            </Box>

            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />
            <InvalidRowsModal name="krakpi" open={invalidRowsModalopen} onClose={handleInvalidRowsModalClose} data={invalidRwModalResponseData} />


        </Box>
    );
};

export default KraKpi;
